import React, { Component } from "react";
import { connect } from "react-redux";
import URLSearchParams from 'url-search-params';
import { Redirect, Route, Switch } from "react-router-dom";
import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";
import { isEmpty } from 'lodash';
import AppLocale from "lngProvider";
import MainApp from "./MainApp";
import SignIn from "../SignIn";
import SignUp from "../SignUp";
import Forbidden from "../Forbidden";
import { setInitUrl, getUserInfo, getListVaiTro } from "appRedux/actions/Auth";
import { getDSHuyen } from 'src/appRedux/actions/DanhMucDungChung';
import { onLayoutTypeChange, onNavStyleChange, setThemeType } from "appRedux/actions/Setting";
import { getCookieValue, getLocalStorage } from 'src/util/Common';
import config from "util/config";

import {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  THEME_TYPE_DARK
} from "src/constants/ThemeSetting";

const RestrictedRoute = ({ component: Component, token, ...rest }) =>
  <Route
    {...rest}
    render={props =>
      (props.location && (props.location.pathname === '/home'))
        ? window.location.href = "https://csdlsocongthuong.quangnam.gov.vn/home/index.html" : (token && (props.location && (props.location.pathname !== '/home/index.html'))) ? <Component {...props} />
          : <Redirect
            to={{
              pathname: '/dang-nhap',
              state: { from: props.location }
            }}
          />
    }
  />;


class App extends Component {

  setLayoutType = (layoutType) => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('full-layout');
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove('full-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('boxed-layout');
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('full-layout');
      document.body.classList.add('framed-layout');
    }
  };

  setNavStyle = (navStyle) => {
    if (navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
      navStyle === NAV_STYLE_DARK_HORIZONTAL ||
      navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
      navStyle === NAV_STYLE_ABOVE_HEADER ||
      navStyle === NAV_STYLE_BELOW_HEADER) {
      document.body.classList.add('full-scroll');
      document.body.classList.add('horizontal-layout');
    } else {
      document.body.classList.remove('full-scroll');
      document.body.classList.remove('horizontal-layout');
    }
  };

  UNSAFE_componentWillMount() {
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
    const params = new URLSearchParams(this.props.location.search);
    if (params.has("theme")) {
      this.props.setThemeType(params.get('theme'));
    }
    if (params.has("nav-style")) {
      this.props.onNavStyleChange(params.get('nav-style'));
    }
    if (params.has("layout-type")) {
      this.props.onLayoutTypeChange(params.get('layout-type'));
    }
  }

  async componentDidUpdate() {
    const { getDSHuyen, vaiTro, getListVaiTro, getUserInfo, authUser } = this.props;
    const accessToken = await getCookieValue('accessTokensct');
    const dsHuyen = await getLocalStorage('dsHuyen');
    if (accessToken) {
      if (!dsHuyen) await getDSHuyen(config.MA_TINH);
      if (isEmpty(vaiTro)) await getListVaiTro();
      if (isEmpty(authUser)) await getUserInfo();
    }
  }

  render() {
    const { match, location, themeType, layoutType, navStyle, locale, token, initURL } = this.props;
    if (themeType === THEME_TYPE_DARK) {
      document.body.classList.add('dark-theme');
    }
    const accessToken = token ? token : getCookieValue('accessTokensct');
    if (location.pathname === '/') {
      if (accessToken === null) {
        return (<Redirect to={'/dang-nhap'} />);
      } else if (initURL === '' || initURL === '/' || initURL === '/dang-nhap') {
        return (<Redirect to={'/user/home'} />);
      } else {
        return (<Redirect to={initURL} />);
      }
    }
    this.setLayoutType(layoutType);
    this.setNavStyle(navStyle);
    const currentAppLocale = AppLocale[locale.locale];
    return (
      <ConfigProvider locale={currentAppLocale.antd}>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}>
          <Switch>
            <Route exact path='/dang-nhap' component={SignIn} />
            <Route exact path='/Forbidden' component={Forbidden} />
            <Route exact path='/signup' component={SignUp} />
            <RestrictedRoute path={`${match.url}`} token={accessToken} component={MainApp} />
          </Switch>
        </IntlProvider>
      </ConfigProvider>
    )
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { locale, navStyle, themeType, layoutType } = settings;
  const { token, initURL, vaiTro, authUser } = auth;
  return { locale, token, navStyle, themeType, layoutType, initURL, vaiTro, authUser }
};
export default connect(mapStateToProps, { setInitUrl, setThemeType, onNavStyleChange, onLayoutTypeChange, getUserInfo, getListVaiTro, getDSHuyen })(App);
